module.exports = __webpack_public_path__ + "f6ae303c75014c8da07910faca8660c6.svg";


//////////////////
// WEBPACK FOOTER
// ./assets/images/logos/orange.svg
// module id = XrqG
// module chunks = 0